export function createRange(number: number): number[] {
  return new Array(number) as number[];
}
